module.exports = __webpack_public_path__ + "img/testim1.068ce7e0.webp";